exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".select{display:flex;flex-direction:row;align-items:center;justify-content:center;margin-top:8px}.select .title{font-weight:bold;width:50%;text-align:right}.select .controls{width:50%}.select .controls select{margin-left:32px}", ""]);

